<script>
export default {
    name: 'oc-icon',
    functional: true,
    props: {
        type: {
            type: String,
            default: 'file'
        },
        source: {
            type: [String, Boolean],
            default: 'font-awesome',
            validator: function (value) {
                return [false, 'font-awesome', 'oc'].indexOf(value) !== -1
            }
        },
        tag: {
            type: String,
            default: 'i'
        }
    },
    render(h, context) {
        let prefixes = {
            'font-awesome' : 'fa fa-',
            'oc' : 'oc-',
        }

        let prefixClasses = ''
        if( false !== context.props.source ) {
            prefixClasses = prefixes[context.props.source]
        }

        let type = context.props.type

        if( context.props.source === 'font-awesome' ) {
            type = type.replace(/^(fa\-)/, '')
        }
        else if( context.props.source === 'oc' ) {
            type = type.replace(/^(oc\-)/, '')
        }

        let classes = [prefixClasses + type, context.data.class]

        return h(
            context.props.tag,
            Object.assign({}, context.data, {
                on: context.listeners,
                class: classes
            }),
            context.children
        )
    }
}
</script>
